module.exports = __webpack_public_path__ + "static/media/themeOn.75ea2814.svg";